import React, { useEffect, useState } from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import Lightbox from 'react-image-lightbox';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import Box from '@mui/material/Box';
import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';
import Button from '@mui/material/Button';

import Grid from '@mui/material/Grid';
import Main from 'layouts/Main';

// import p1 from 'assests/Photos/SchoolProgram/2024/orientation/1.jpg';
// import p2 from 'assests/Photos/SchoolProgram/2024/orientation/2.jpg';
// import p3 from 'assests/Photos/SchoolProgram/2024/orientation/3.jpg';
// import p4 from 'assests/Photos/SchoolProgram/2024/orientation/4.jpg';
// import p5 from 'assests/Photos/SchoolProgram/2024/orientation/5.jpg';
// import p6 from 'assests/Photos/SchoolProgram/2024/orientation/6.jpg';


// import p5 from 'assests/Photos/SchoolProgram/2023/Valediction_ceremony/5.jpg';
// import p6 from 'assests/Photos/SchoolProgram/2023/RepublicDay/6.jpg';
// import p7 from 'assests/Photos/SchoolProgram/2023/RepublicDay/7.jpg';
// import p8 from 'assests/Photos/SchoolProgram/2023/RepublicDay/8.jpg';
// import p9 from 'assests/Photos/SchoolProgram/2023/RepublicDay/9.jpg';
// import p10 from 'assests/Photos/SchoolProgram/2023/RepublicDay/10.jpg';


import { Typography } from '@mui/material';
import Container from 'components/Container';
import { Sidebar2023 } from 'views/SchoolProgram2023/components';
import Sidebar2024 from '../SchoolProgram2023/components/Sidebar2024';
import Archive2022 from '../SchoolProgram2023/components/Archive2022';
import { Sidebar2025 } from '../SchoolProgram2023/components';

const KannadaRajyotsava2025 = () => {
    const theme = useTheme();
    const [currentImage, setCurrentImage] = useState(0);
    const [viewerIsOpen, setViewerIsOpen] = useState(false);

    const openLightbox = (index) => {
        setCurrentImage(index);
        setViewerIsOpen(true);
    };

    const closeLightbox = () => {
        setCurrentImage(0);
        setViewerIsOpen(false);
    };

    const isMd = useMediaQuery(theme.breakpoints.up('md'), {
        defaultMatches: true,
    });
    const [config, setConfig] = useState({ base_image_url_2025: '' });
    useEffect(() => {
      fetch('/config.json')  // For Gatsby, this will resolve to /config.json from the static folder
        .then(response => response.json())
        .then(data => setConfig(data))
        .catch(error => console.error('Error fetching config:', error));
    }, []);
    
const p1 = `${config.base_image_url_2025}/home/events-activities/school-programs/Kannada/1.webp`;
const p2 = `${config.base_image_url_2025}/home/events-activities/school-programs/Kannada/2.webp`;
const p3 = `${config.base_image_url_2025}/home/events-activities/school-programs/Kannada/3.webp`;
const p4 = `${config.base_image_url_2025}/home/events-activities/school-programs/Kannada/4.webp`;
const p5  = `${config.base_image_url_2025}/home/events-activities/school-programs/Kannada/5.webp`;
const p6  = `${config.base_image_url_2025}/home/events-activities/school-programs/Kannada/6.webp`;
const p7  = `${config.base_image_url_2025}/home/events-activities/school-programs/Kannada/7.webp`;
const p8  = `${config.base_image_url_2025}/home/events-activities/school-programs/Kannada/8.webp`;
const p9  = `${config.base_image_url_2025}/home/events-activities/school-programs/Kannada/9.webp`;  
const p10 = `${config.base_image_url_2025}/home/events-activities/school-programs/Kannada/10.webp`;
const p11 = `${config.base_image_url_2025}/home/events-activities/school-programs/Kannada/11.webp`;
const p12 = `${config.base_image_url_2025}/home/events-activities/school-programs/Kannada/12.webp`;
const p13 = `${config.base_image_url_2025}/home/events-activities/school-programs/Kannada/13.webp`;
const p14 = `${config.base_image_url_2025}/home/events-activities/school-programs/Kannada/14.webp`;
const p15 = `${config.base_image_url_2025}/home/events-activities/school-programs/Kannada/15.webp`;
const p16 = `${config.base_image_url_2025}/home/events-activities/school-programs/Kannada/16.webp`;


        

    
    
   
    const photos = [
         {
  src: p1,
  source: p1,
  rows: 1,
  cols: 1,
},
{
  src: p2,
  source: p2,
  rows: 1,
  cols: 1,
},
{
  src: p3,
  source: p3,
  rows: 1,
  cols: 1,
}, 
{
  src: p4,
  source: p4,
  rows: 1,
  cols: 1,
},
{
  src: p5,
  source: p5,
  rows: 1,
  cols: 1,
},
{
  src: p6,
  source: p6,
  rows: 1,
  cols: 1,
},
{
  src: p7,
  source: p7,
  rows: 1,
  cols: 1,
},
{
  src: p8,
  source: p8,
  rows: 1,
  cols: 1,
},
{
  src: p9,
  source: p9,
  rows: 1,
  cols: 1,
},
{
  src: p10,
  source: p10,
  rows: 1,
  cols: 1,
},
{
  src: p11,
  source: p11,
  rows: 1,
  cols: 1,
},
{
  src: p12,
  source: p12,
  rows: 1,
  cols: 1,
},
{
  src: p13,
  source: p13,
  rows: 1,
  cols: 1,
},
{
  src: p14,
  source: p14,
  rows: 1,
  cols: 1,
},
{
  src: p15,
  source: p15,
  rows: 1,
  cols: 1,
},
{
  src: p16,
  source: p16,
  rows: 1,
  cols: 1,
}

    ];

    return (
        <Main>
            <Container>
                <Grid container spacing={4}>
                    <Grid item xs={12} md={8}>
                        <Box>

                            <Box >
                                <Typography variant='h5' align='center'>
                           Kannada Rajyotsava
                                </Typography>
                                {/* <Typography
                                    fontSize="x-small"
                                ><br /><br />
                               Class: 7     Date: 29 October 2025
                                </Typography> */}
                                <Typography
                                variant={'h6'}
                                color={'primary'}
                                align={'center'}
                                fontWeight={'normal'}
                            ><br />
                                “ Wherever we are, we must remember that the soil of our land has given us everything — our food, our knowledge and our identity. We must give back with dedication and gratitude. -Dr A.P.J. Abdul Kalam ”

                                <br />
                            </Typography>

                                <br />
                                <Typography variant={'subtitle1'} align={'justify'}>
Kannada Rajyotsava was celebrated with great enthusiasm and grandeur on Friday, 7th November 2025 at National Public School, Yeshwanthpur. The entire campus sported a vibrant wave of red and yellow, the colours of the Karnataka flag, with beautiful decorations, helium balloons and teachers dressed in matching attire that added to the festive spirit. 
<br></br>
The celebration commenced with the lighting of the lamp, followed by an inspiring speech in Kannada that set the tone for the event. The glory of Karnataka was brought to life through a melodious song, a captivating group dance and a remarkable street play performance that portrayed the state’s rich and diverse culture.
<br></br>
Principal Ma’am encouraged students to take pride in Karnataka’s dynamic culture and multilingual heritage, urging them to contribute wholeheartedly to the state’s progress. She also reminded everyone that we must be grateful for the state we are born in, which nurtures and inspires us.
<br></br>
The event concluded with a heartfelt rendition of the state anthem, ‘Jaya Bharata Jananiya Tanujate’ leaving everyone filled with pride and joy. The celebration was a resounding success, truly embodying the spirit of Karnataka and unity among all.
                               <br></br>
                                  </Typography>
                            </Box>
                            <Typography
                                variant={'h6'}
                                color={'primary'}
                                align={'center'}
                                fontWeight={'normal'}
                            ><br />
                                “KANNADAVE SATHYA KANNADAVE NITHYA”

                                <br />
                            </Typography>

                            <Box>
                                <ImageList
                                    variant="quilted"
                                    cols={2}
                                    rowHeight={isMd ? 300 : 200}
                                    gap={isMd ? 16 : 4}
                                >
                                    {photos.map((item, i) => (
                                        <ImageListItem key={i} cols={item.cols} rows={item.rows}>
                                            <LazyLoadImage
                                                height={'100%'}
                                                width={'100%'}
                                                src={item.src}
                                                alt="..."
                                                effect="blur"
                                                onClick={() => openLightbox(i)}
                                                style={{
                                                    objectFit: 'cover',
                                                    filter:
                                                        theme.palette.mode === 'dark' ? 'brightness(0.7)' : 'none',
                                                    cursor: 'poiner',
                                                    borderRadius: 8,
                                                }}
                                            />
                                        </ImageListItem>
                                    ))}
                                </ImageList>
                            </Box>
                            {viewerIsOpen && (
                                <Lightbox
                                    mainSrc={photos[currentImage].src}
                                    nextSrc={photos[(currentImage + 1) % photos.length].src}
                                    prevSrc={
                                        photos[(currentImage + photos.length - 1) % photos.length].src
                                    }
                                    onCloseRequest={() => closeLightbox()}
                                    onMovePrevRequest={() =>
                                        setCurrentImage((currentImage + photos.length - 1) % photos.length)
                                    }
                                    onMoveNextRequest={() =>
                                        setCurrentImage((currentImage + 1) % photos.length)
                                    }
                                    reactModalStyle={{ overlay: { zIndex: 1500 } }}
                                />
                            )}
                        </Box>
                    </Grid>
                    <Grid item xs={12} md={4}>
                    <Box marginBottom={4}>
                            <Sidebar2025/>
                        </Box> 
                        <Box marginBottom={4}>
                            <Archive2022/>
                        </Box>

                    </Grid>
                </Grid>
            </Container>
        </Main>

    );
};

export default KannadaRajyotsava2025;